// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_1q_XP","hidden":"BQnh4","loader":"_29jrw","rotate":"_1LTx5","active":"_2iWWy","clip":"_37zVR","clip-reverse":"_11Osh","clipReverse":"_11Osh"};